import { MediaType } from '../../constants/MediaType';
import { toFolder } from './mappers/folder';
import { toError } from './parsers/error';
import { parseFolderId } from './parsers/folder-id';
export function initFolders(settings, http) {
  const defaultPaging = {
    size: 50,
    cursor: null
  };
  function list(folderId, options) {
    if (options === void 0) {
      options = {};
    }
    const paging = {
      ...defaultPaging,
      ...options.paging
    };
    const {
      mediaType
    } = parseFolderId(folderId);
    const apiUrl = mediaType === MediaType.Picture ? settings.pictureApi : settings.videoApi;
    return http.get(`${apiUrl}/categories`).then(response => {
      response.data = [{
        id: 'any',
        name: 'All'
      }, ...response.data.data].map(item => toFolder(item, mediaType));
      response.paging = {
        size: paging.size,
        cursor: null
      };
      return response;
    }).catch(toError);
  }
  return {
    list
  };
}